import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { AddCustomerComponent } from './add-customer/add-customer.component';
import { CustomerUsersFormComponent } from './customer-users-form/customer-users-form.component';
import { CustomerUserFormComponent } from './customer-user-form/customer-user-form.component';

@NgModule({
  declarations: [
    AddCustomerComponent,
    CustomerUsersFormComponent,
    CustomerUserFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedComponentsModule
]
})
export class SalesModule { }
